<template>
  <b-form-group label="Cidade:">
    <b-form-select
      v-model="valor"
      :options="cidades"
      v-if="cidades.length"
      @change="$emit('change')"
    ></b-form-select>
    <b-form-input
      type="text"
      v-model="valor"
      placeholder="Cidade"
      v-if="!cidades.length"
    ></b-form-input>
  </b-form-group>
</template>

<style lang="scss" scoped></style>

<script>
export default {
  name: "InputCidade",
  data() {
    return {};
  },
  computed: {
    valor: {
      get: function() {
        return this.value;
      },
      set: function(newValue) {
        this.$emit("input", newValue);
      }
    }
  },
  props: ["value", "cidades"],
  methods: {}
};
</script>
